/*
 *                     NOTICE
 *            COPYRIGHT 2020 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { Expression } from "abreact/expression/Expression";
import { AbImmutableRecord } from "abreact/utils/AbImmutableRecord";
import * as Immutable from "immutable";
export let GuidedExpressionEditor;
(function (_GuidedExpressionEditor) {
  let AbstractModel;
  (function (_AbstractModel) {
    let AbstractRowModel;
    (function (_AbstractRowModel) {
      let AbstractOperandValue;
      (function (_AbstractOperandValue) {
        function equals(a, b) {
          return Expression.Node.Producer.equals(a, b);
        }
        _AbstractOperandValue.equals = equals;
      })(AbstractOperandValue || (AbstractOperandValue = _AbstractRowModel.AbstractOperandValue || (_AbstractRowModel.AbstractOperandValue = {})));
      let AbstractLeafOperandValue;
      (function (_AbstractLeafOperandValue) {
        function partialState(partialState) {
          return partialState;
        }
        _AbstractLeafOperandValue.partialState = partialState;
      })(AbstractLeafOperandValue || (AbstractLeafOperandValue = _AbstractRowModel.AbstractLeafOperandValue || (_AbstractRowModel.AbstractLeafOperandValue = {})));
      let OperatorOperandValue;
      (function (_OperatorOperandValue) {
        function partialState(partialState) {
          return partialState;
        }
        _OperatorOperandValue.partialState = partialState;
        function partialStateFromExpOperator(expOperator, expressionDomainModel) {
          const {
            categoryID,
            valueTypeID,
            multiple,
            outputQualifier
          } = expOperator.output;
          return {
            valueCategoryID: categoryID,
            valueTypeIDs: Immutable.List.of(valueTypeID),
            multiple: multiple ?? false,
            typeQualifier: outputQualifier,
            expOperatorObject: AbImmutableRecord.State.Object.from(expOperator),
            isPlaceholder: expressionDomainModel.isPlaceholderExpOperator(expOperator)
          };
        }
        _OperatorOperandValue.partialStateFromExpOperator = partialStateFromExpOperator;
      })(OperatorOperandValue || (OperatorOperandValue = _AbstractRowModel.OperatorOperandValue || (_AbstractRowModel.OperatorOperandValue = {})));
      let ActionListOperandValue;
      (function (_ActionListOperandValue) {
        function partialState(partialState) {
          return partialState;
        }
        _ActionListOperandValue.partialState = partialState;
      })(ActionListOperandValue || (ActionListOperandValue = _AbstractRowModel.ActionListOperandValue || (_AbstractRowModel.ActionListOperandValue = {})));
    })(AbstractRowModel || (AbstractRowModel = _AbstractModel.AbstractRowModel || (_AbstractModel.AbstractRowModel = {})));
  })(AbstractModel || (AbstractModel = _GuidedExpressionEditor.AbstractModel || (_GuidedExpressionEditor.AbstractModel = {})));
  let AbstractRowBasedModel;
  (function (_AbstractRowBasedModel) {
    function defaultDeepCompareReplacer(key, value) {
      switch (key) {
        case "generateId":
        case "generateKey":
          return undefined;
        case "expOperatorObject":
          return value.value;
      }
      return value;
    }
    _AbstractRowBasedModel.defaultDeepCompareReplacer = defaultDeepCompareReplacer;
  })(AbstractRowBasedModel || (AbstractRowBasedModel = _GuidedExpressionEditor.AbstractRowBasedModel || (_GuidedExpressionEditor.AbstractRowBasedModel = {})));
})(GuidedExpressionEditor || (GuidedExpressionEditor = {}));
//# sourceMappingURL=GuidedExpressionEditor.js.map
